('use strict');
import 'vendor/jquery.isOnScreen';
import { Tracking } from './fathomTracking';
import Domain from 'helpers/Domain';

let track = null;

/**
 * GridFathomTracking
 * Currently only available for US
 */
export default class GridFathomTracking {
    static needToDoInitialTracking = true;
    static scrollIsMonitored = false;
    static resizing = false;
    static scrollInterval = undefined;
    static resizeInterval = undefined;
    constructor(wrappers, delay = 2000) {
        this.wrappers = wrappers;

        if (track === null) {
            track = new Tracking();
            track.buildMetaData();
        }

        this.setFathomTracking();

        this.targets = this.findTargets();

        this.delay = delay;

        this.triggerScrollDebounce = () => this.scrollDebounce(this.track, this.delay);
        this.triggerResizeDebounce = () => this.resizeDebounce(this.track, this.delay);

        // Track initial grid
        if (GridFathomTracking.needToDoInitialTracking) {
            GridFathomTracking.needToDoInitialTracking = false;
            setTimeout(async () => {
                await this.track();
                await this.addEvents();
            }, 3000);
        }
    }

    buildPayLoad(containers = null, item = null) {
        containers =
            containers ??
            this.wrappers
                .filter((container) => {
                    if (!item) {
                        return $(container).isOnScreen(1, 1, true, true);
                    }

                    return (
                        $(container).isOnScreen(1, 1, true, true) &&
                        $(item).isOnScreen(1, 1, true, true) &&
                        container.contains(item)
                    );
                })
                .map((container) => $(container)) ??
            null;

        if (!containers || containers.length < 1) return null;

        const payloads = containers
            .map((container) => {
                const carouselId = container.data('gridid');
                if (
                    !container.data('displayid') ||
                    !container.data('recoid') ||
                    !container.data('title')
                )
                    return null;

                this.display_id = container.data('displayid').toString();
                const videoBoxContainer = container.children('.video-carousel-box');
                const pvrModel = videoBoxContainer.data('pvrmodel');

                const payload = {
                    reco_id: container.data('recoid').toString(),
                    display_id: this.display_id,
                    display_name: container.data('title').toString(),
                    position: container.data('position'),
                    rank_model: container.data('rankmodel')?.toString(),
                    pvr_model: pvrModel?.toString() ?? '',
                    content: this.buildGridContent(container, item),
                };

                if (carouselId) {
                    payload.carousel_id = carouselId;
                }

                return payload;
            })
            .filter((container) => container?.content != undefined);

        return payloads;
    }

    buildGridContent(container, item = null) {
        let items = item ? [item] : Array.from(container.find('a'));
        items = items.filter((element) => {
            if (item) {
                return $(element).isOnScreen(1, 1, true, true);
            }
            return $(element).isOnScreen(1, 1, false, true);
        });
        if (items.length) {
            let content = [];
            for (const grid in items) {
                const g = items[grid];
                if (g && typeof g === 'object') {
                    const $g = $(g);
                    const dataFathom = $g.data('fathom')?.split('|');
                    const content_id = dataFathom[0]?.toString() ?? '';
                    const content_title = dataFathom[5]?.toString() ?? '';
                    let position = Number(dataFathom[2] ?? 0);
                    content.push({
                        content_id,
                        content_title,
                        content_type: dataFathom[3].toString() ?? '',
                        position,
                    });
                    this.setPayloadClick($g, this.display_id, content_id, content_title);
                } else break;
            }
            return content;
        }
    }

    setPayloadClick(grid, display_id, content_id, content_title) {
        grid.off('click', this.clickHandler).on(
            'click',
            { display_id, content_id, content_title },
            this.clickHandler,
        );
    }

    findTargets() {
        let targets = this.wrappers
            .map((wrapper) => [...wrapper.querySelectorAll('article')])
            .map((items) => {
                return items.map((item) => {
                    let attr = item.getAttribute('class').trim().replace(/\s/g, '.') + ' ' + 'a';
                    return `.${attr}`;
                });
            })
            .join(', ');

        return targets;
    }

    eventScrollDebounce() {
        if (!GridFathomTracking.scrollIsMonitored) {
            GridFathomTracking.scrollIsMonitored = true; // prevents more than one scroll listener from being added
            window.addEventListener('scroll', this.triggerScrollDebounce);
        }
    }

    scrollDebounce(callback, delay) {
        if (GridFathomTracking.resizing || GridFathomTracking.needToDoInitialTracking) return;
        let pageYOffset = window.scrollY;
        if (GridFathomTracking.scrollInterval === undefined) {
            // prevents additional scrolling from creating additional intervals
            GridFathomTracking.scrollInterval = setInterval(() => {
                if (pageYOffset === window.scrollY) {
                    clearInterval(GridFathomTracking.scrollInterval);
                    callback();
                    GridFathomTracking.scrollInterval = undefined;
                } else {
                    pageYOffset = window.scrollY;
                }
            }, delay);
        }
    }

    eventResizeDebounce() {
        if (!GridFathomTracking.resizing) {
            window.addEventListener('resize', this.triggerResizeDebounce);
        }
    }

    resizeDebounce(callback, delay) {
        if (
            GridFathomTracking.resizeInterval === undefined &&
            !GridFathomTracking.needToDoInitialTracking
        ) {
            GridFathomTracking.resizing = true;
            GridFathomTracking.resizeInterval = setInterval(() => {
                clearInterval(GridFathomTracking.resizeInterval);
                callback();
                GridFathomTracking.resizeInterval = undefined;
                GridFathomTracking.resizing = false;
            }, delay);
        }
    }

    addEvents() {
        this.eventScrollDebounce();
        // Unable Resize Events
        // this.eventResizeDebounce();
        if (this.targets.length) {
            $(document).on('click', `${this.targets}`, this.clickHandler);
        }
    }

    removeEventScrollDebounce() {
        window.removeEventListener('scroll', this.triggerScrollDebounce);
    }

    removeEventResizeDebounce() {
        window.removeEventListener('resize', this.triggerResizeDebounce);
    }

    removeEvents() {
        GridFathomTracking.needToDoInitialTracking = true;
        GridFathomTracking.scrollIsMonitored = false;
        GridFathomTracking.resizing = false;
        GridFathomTracking.scrollInterval = undefined;
        GridFathomTracking.resizeInterval = undefined;
        this.removeEventScrollDebounce();
        // Unable Resize Events
        // this.removeEventResizeDebounce();
        $(document).off('click', `${this.targets}`, this.clickHandler);
    }

    clickHandler = (event) => {
        track.trackObject(track.getFathomClickUrl(), {
            display_id: event.data.display_id,
            content_id: event.data.content_id,
            content_title: event.data.content_title,
        });
    };

    track = (trackObject = null) => {
        trackObject = trackObject ?? this.buildPayLoad();
        if (trackObject) {
            trackObject = Array.isArray(trackObject) ? trackObject : [trackObject];
            this.trackObject(trackObject);
        }
    };

    trackObject(trackObject) {
        if (!this.suppressTracking() && trackObject && trackObject.length > 0) {
            track.trackWrappers(trackObject);
        }
    }

    suppressTracking() {
        // Only available for US
        let profile_type = CBS.Registry?.user?.profile_type?.toString() ?? '';

        return (
            profile_type != 'ADULT' ||
            window.location.href.includes('user-profile') ||
            Domain.isInternational()
        );
    }

    setFathomTracking() {
        this.wrappers.map((element) => {
            const $element = $(element);

            const payload = this.buildPayLoad([$element]);
            if (!payload || payload.content === undefined) {
                return;
            }
            track.addWrapper($element);
            track.addPayLoad(payload);
        });
    }
}
